import { Table } from 'react-bootstrap'

import styled from 'styled-components'

export interface DisplayableObject {
  displayName: string
}

export interface DetailTableProps {
  title: React.ReactNode
  children: any
  style?: React.CSSProperties | undefined
  id?: string
}

export interface TableItemProps {
  label: string
  value: string | DisplayableObject[] | React.ReactNode | string[]
  whenEmpty?: 'display' | 'hide'
}

export interface TableSubTableProps {
  children: React.ReactNode
}

export function DetailTable({ title, children, style, id }: DetailTableProps) {
  return (
    <section style={style}>
      {typeof title === 'string' ? <Title>{title}</Title> : title}

      <Table style={{ marginBottom: '0', verticalAlign: 'unset' }} id={id}>
        <tbody>{children}</tbody>
      </Table>
    </section>
  )
}

DetailTable.Item = function ({
  label,
  value,
  whenEmpty = 'hide',
}: TableItemProps) {
  const displayValue = Array.isArray(value)
    ? value
        .map((kvp) => {
          if (!kvp) {
            return null
          }

          if (typeof kvp === 'string') {
            return kvp.trim()
          }

          return kvp?.displayName.trim()
        })
        .filter(Boolean)
        .sort()
        .join(', ')
    : value

  const display = !!displayValue || whenEmpty === 'display'
  if (!display) {
    return null
  }

  return (
    <tr>
      <td style={{ width: '10rem' }}>{label}</td>
      <td>{displayValue}</td>
    </tr>
  )
}

DetailTable.SubTable = function ({ children }: TableSubTableProps) {
  return (
    <SubTableStyled size="sm" borderless>
      <tbody>{children}</tbody>
    </SubTableStyled>
  )
}

const SubTableStyled = styled(Table)`
  margin: 0;

  td {
    padding-left: 0;
    width: 20rem;
  }

  tr {
    display: flex;
  }
`

const Title = styled.h6`
  font-weight: 700;
`

DetailTable.Title = Title
